// extracted by mini-css-extract-plugin
module.exports = {"auto-text":"styles_auto-text__vAfRM"};